module.exports = __webpack_public_path__ + "static/media/logo-footer.f044b61e.svg";